import { debounce } from '../../js/helpers/throttle-debounce';

function handleOrientation(player) {
    player.one('playing', () => {
        player.el().dataset.videoOrientation = '';
        player.addClass('vjs-auto-width');
        const { clientWidth: techWidth, clientHeight: techHeight } = player.tech().el();
        player.removeClass('vjs-auto-width');
        player.el().dataset.videoOrientation = techWidth > techHeight ? 'landscape' : 'portrait';
    });
}

function handleViewMode(player) {
    const isResponsive = player.el().style.width.slice(-1) === '%';
    const isIframe = window !== parent;
    const isFluid = isResponsive || isIframe;

    function setViewMode() {
        const playerStyle = getComputedStyle(player.el());
        const playerWidth = player.el().clientWidth + parseInt(playerStyle.marginLeft, 10) + parseInt(playerStyle.marginRight, 10);
        const parentWidth = player.el().parentElement.clientWidth;
        const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
        const isFullscreen = fullscreenElement === player.el();
        let containerWidth = isFluid ? parentWidth : playerWidth;

        player.el().dataset.viewMode = containerWidth < 768 || isFullscreen ? 'mobile'
            : 768 <= containerWidth && containerWidth <= 1024 ? 'tablet'
            : 'desktop';
        player.trigger('change-view-mode');
    }
    player.one('playing', setViewMode);
    isFluid && player.on('playerresize', setViewMode);
}

function handlePlayerHeight(player) {
    if (!player.hasPlugin('chat') && !player.hasPlugin('streamShopping')) {
        return;
    }
    player.one('playing', () => {
        const chatMessanger = player.getChild('ChatMessanger');
        const listProducts = player.getChild('ListProducts');
        function reset() {
            player.removeClass('vjs-responsive-ui-landscape');
            player.removeClass('vjs-responsive-ui-portrait');
            if (chatMessanger) {
                chatMessanger.resetHeight();
            }
            if (listProducts) {
                listProducts.resetHeight();
            }
        }
        function setHeight() {
            const { viewMode, videoOrientation } = player.el().dataset;
            reset();
            if (viewMode !== 'tablet') return;
            // Значение --player-height долно быть в px иначе margin (который рассчитывается в ./index.scss)
            // будет рассчитан исходя из ширины контейнера
            player.el().style.setProperty('--player-height', videojs.computedStyle(player.el(), 'height'));
            if (videoOrientation === 'landscape') {
                player.addClass('vjs-responsive-ui-landscape');
                player.removeClass('vjs-responsive-ui-portrait');
            } else {
                player.removeClass('vjs-responsive-ui-landscape');
                player.addClass('vjs-responsive-ui-portrait');
            }
            const marginBottom = videojs.computedStyle(player.el(), 'margin-bottom');
            if (chatMessanger) {
                chatMessanger.setHeight(marginBottom);
            }
            if (listProducts) {
                listProducts.setHeight(marginBottom);
            }
        }
        setHeight();
        player.on('playerresize', setHeight);
    });
}

function handlePlayerWidth(player) {
    const isResponsive = player.el().style.width.slice(-1) === '%';
    const isIframe = window !== parent;
    const isFluid = isResponsive || isIframe;

    player.el().dataset.fluid = isFluid.toString();

    player.one('playing', () => {
        function handler() {
            //handler сам по себе провоцирует событие playerresize, deboncedAddListenerResize позволяет дождаться, когда этот
            //playerresize завершится, и в этот момент вешает на playerresize уже ф-ю handler, убирая до сдедующего вызова
            //handler ф-ю deboncedAddListenerResize
            //Проблема в том, что есть необходимость реагировать на playerresize двумя способами:
            //если этот playerresize вызван самой ф-ей handler, то не нужно ничего делать и вызывать ее повторно,
            //а вот если playerresize вызван любой другой внешней причиной, то нужно вызывать handler, который подгоняет размер плеера
            //таким образом мы переключаем на playerresize вызов двух ф-ий: пока шуршит сам handler, мы ждем окончания его работы
            //с помощью deboncedAddListenerResize и по завершеннии playerresize вешаем уже прослушиватель, который впоследствии вызовет handler

            const deboncedAddListenerResize = debounce(300, false, addListenerResize);
            function addListenerResize() {
                player.off('playerresize', deboncedAddListenerResize);
                player.on('playerresize', handler);
            }
            const { viewMode, videoOrientation } = player.el().dataset;
            if (viewMode === 'desktop' && videoOrientation === 'portrait') {
                player.off('playerresize', handler );//снимаем handler, чтоб не вызывался зря в результате отработки самого handler
                player.on('playerresize', deboncedAddListenerResize);

                player.el().style.removeProperty('--free-space-around-tech');

                const parentWidth = player.el().parentElement.clientWidth;
                const playerTechWidth = player.tech().currentWidth();
                let freeSpaceAroundTech;

                if (isFluid) {
                    freeSpaceAroundTech = Math.floor(parentWidth - Math.max(playerTechWidth, 300));
                } else {
                    freeSpaceAroundTech = 720;
                    player.el().style.setProperty('width', `${playerTechWidth}px`);
                }

                player.el().style.setProperty('--free-space-around-tech', `${freeSpaceAroundTech}px`);
            }
        };

        handler();
    });
}

let playerIds = [];

export function composeUI(player) {
    const id = player.id();
    if (playerIds.includes(id)) return;
    playerIds.push(id);

    player.addClass('vjs-compose-ui');

    player.on('ready', () => {
        handleOrientation(player);
        handleViewMode(player);
        handlePlayerWidth(player);
        handlePlayerHeight(player);
    });

    player.on('dispose', () => {
       const index = playerIds.indexOf(id);
       playerIds.splice(index, 1);
    });
}
